module.exports = __webpack_public_path__ + "static/img/joinUs-bg.f6cf8b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/joinUs-bg.jpg
// module id = h38m
// module chunks = 4